import { Button } from "antd";
const GrtInput = (props) => {
    return (<Button>{props.message}</Button>);
};
export default GrtInput;
